import { render } from "./vwithdrawalremind.vue?vue&type=template&id=2f1754bc&scoped=true"
import script from "./vwithdrawalremind.vue?vue&type=script&lang=js"
export * from "./vwithdrawalremind.vue?vue&type=script&lang=js"

import "./vwithdrawalremind.vue?vue&type=style&index=0&id=2f1754bc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1754bc"]])

export default __exports__